//EntityList.vue
<template>
  <div id="app">
    <div id="content">
      <!-- <Header
        v-if="parseInt(persons.length) < parseInt(estimate)"
        :page="type"
        :title_one="'team'"
        :title_two="'titles.' + type"
        :action_one="'add'"
      ></Header> -->
      <Header
        v-if="parseInt(persons.length) < parseInt(estimate)"
        :page="type"
        :title_one="type"
        :action_one="event.main_actions ? 'add' : ''"
      ></Header>
      <Header v-else :page="type" :title_one="type"></Header>
      <PersonList
        @load="load()"
        :persons="persons"
        :type="type"
        :team="team"
        @remove="remove"
        :estimate="estimate"
        :estimate_minimum="estimate_minimum"
        :key="this.$route.fullPath"
      ></PersonList>
    </div>
  </div>
</template>
<script>
/* global ObjectToArray */
import PersonList from '@/components/ui/PersonList'
import Header from '@/components/layout/Header'

export default {
  name: 'EntityList',
  components: {
    PersonList,
    Header
  },
  data () {
    return {
      team: {},
      persons: [],
      type: '',
      estimate: null,
      estimate_minimum: null
    }
  },
  computed: {
    user () {
      return this.$store.getters['user/getUser']
    },

    event () {
      return this.$store.getters['getCurrentEvent']()
    }
  },
  methods: {
    load () {
      this.type = this.$route.name

      if (this.user.admin) {
        this.loadClubEvent(this.user.club_id, this.user.event_id)
      }

      this.$store.dispatch('team/loadTeam', { team_id: this.$route.params.team_id })
        .then(() => {
          const data = this.$store.getters['team/getTeam']
          if (this.shouldRedirectFromAcompanyants(data)) {
            this.$router.push({ name: 'team', params: { id: data.team.id } }).catch(() => {})
            return
          }

          this.team = data
          this.persons = ObjectToArray(data[this.type])
          this.setEstimateValues()
        })
    },
    shouldRedirectFromAcompanyants (data) {
      return this.type === 'acompanyants' && String(data.team.mode) === '0'
    },
    loadClubEvent (clubId, eventId) {
      this.$store.dispatch('club/loadClubEvent', {
        club_id: clubId,
        event_id: eventId
      }).then(() => {})
    },
    setEstimateValues () {
      const team = this.team.team

      switch (this.type) {
        case 'players':
          this.estimate = team.estimate_players ? parseInt(team.estimate_players) : null
          this.estimate_minimum = parseInt(team.category.minimum_players)
          break

        case 'staff':
          this.estimate = team.estimate_staff ? parseInt(team.estimate_staff) : null
          this.estimate_minimum = 1
          break

        case 'acompanyants':
          this.estimate = team.estimate_acompanyants ? parseInt(team.estimate_acompanyants) : null
          this.estimate_minimum = 0
          break
      }
    },
    remove (id) {
      for (var person in this.persons) {
        if (this.persons[person].id === id) {
          this.persons.splice(person, 1)
        }
      }
    }
  },
  watch: {
    // call again the method if the route changes
    $route: 'load'
  },
  created () {
    this.load()
  }
}
</script>
<style lang="scss" scoped>
#app {
  background-color: #fff;
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>
